import type { NavigateOptions } from 'react-router-dom';

/**
 * I-1274 (IU-14, found with IL-18): the item page's ⌃ ⌄ replace the history entry, so Back still
 * returns to the list — and a replace is not a push, so `useKeepPosition` gave the item stepped to
 * the offset kept for it, and an item read earlier this session opened where it had been left. A
 * step opens the next item at its top, as Mail's arrows do; the entry it writes says it was a step.
 */
const STEP = 'step';

interface IStepNavigationState {
  readonly arrival?: unknown;
}

/** The navigate options of a step: `replace`, with the step's mark in `state`. */
export function stepNavigation(): NavigateOptions & { state: Record<string, unknown> } {
  return { replace: true, state: { arrival: STEP } };
}

/** Whether a location's state was written by `stepNavigation()`. */
export function isStepNavigationState(state: unknown): boolean {
  return (
    typeof state === 'object' && state !== null && (state as IStepNavigationState).arrival === STEP
  );
}
